// Your existing code for handling sidebar-link click events
const accordionItems = document.querySelectorAll('.sidebar-link');

accordionItems.forEach((item) => {
  item.addEventListener('click', () => {
    // Toggle the active class for the clicked sidebar-link
    item.classList.toggle('active');
    if ($('.sidebar-link.active').length === 0) {
      $('.sidebar-link[data-category="all"]').addClass('active');
    }
    filterCategoryWrappers();
  });
});




const accordionButtons = document.querySelectorAll('.filterSidebar_seperator');

accordionButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const listItem = button.parentElement;
    listItem.classList.toggle('active');
    filterCategoryWrappers();
  });
});

const divs = document.querySelectorAll('.filter-btn');

divs.forEach(div => {
  div.addEventListener('click', () => {
    const parentBox = div.closest('.pageDocuments_container_wrapper');
    if (parentBox) {
      parentBox.classList.add('active');
    }
  });
});

const closeButtons = document.querySelectorAll('.close-btn');

closeButtons.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const parentBox = button.closest('.pageDocuments_container_wrapper');
    if (parentBox) {
      parentBox.classList.remove('active');
    }
  });
});

function filterCategoryWrappers() {
     if ($('.sidebar-link.active').length === 0) {
      $('.sidebar-link[data-category="all"]').addClass('active');
    }
  var activeCategories = [];

  accordionItems.forEach((item) => {
    if (item.classList.contains('active')) {
      var category = item.getAttribute('data-category');
      activeCategories.push(category);
    }
  });

  accordionButtons.forEach((button) => {
    if (button.parentElement.classList.contains('active')) {
      var category = button.parentElement.getAttribute('data-category');
      activeCategories.push(category);
    }
  });

  if (activeCategories.length === 0) {
    activeCategories.push('all');
  }

  activeCategories = [...new Set(activeCategories)];

  // Remove the following line
  // $('#note').text('Select a product');

  if (activeCategories.includes('all')) {
    $('.pageDocuments_categoryWrapper').show();
  } else {
    $('.pageDocuments_categoryWrapper').hide();

    activeCategories.forEach((category) => {
      $(`.pageDocuments_categoryWrapper[data-category-wrapper='${category}']`).show();
    });
  }
}

const selectorss = {
  categoryLinks: '[data-category]',
  categoryWrappers: '.pageDocuments_categoryWrapper',
  categoryMobileSelect: '.pageDocuments_filterSidebarSelect'
};

$(selectorss.categoryLinks).on('click', (evt) => {
  var category = $(evt.currentTarget).data('category');

  if (category == "all") {
    $(selectorss.categoryWrappers).show();
    $(`${selectorss.categoryLinks}[data-category!="all"]`).removeClass('active');
  } else {
    $(selectorss.categoryWrappers).hide();
    var currentCategory = $(
      `${selectorss.categoryWrappers}[data-category-wrapper='${category}']`
    )
    currentCategory.show();
    $(`${selectorss.categoryLinks}[data-category="all"]`).removeClass('active');
  }

  filterCategoryWrappers();
  return false;
});

$(selectorss.categoryMobileSelect).on('change', (evt) => {
  var category = $(evt.currentTarget).val();

  if (category == "all") {
    $(selectorss.categoryWrappers).show();
    $(`${selectorss.categoryLinks}[data-category!="all"]`).removeClass('active');
  } else {
    $(selectorss.categoryWrappers).hide();
    var currentCategory = $(
      `${selectorss.categoryWrappers}[data-category-wrapper='${category}']`
    )
    currentCategory.show();
    $(`${selectorss.categoryLinks}[data-category="all"]`).removeClass('active');
  }

  filterCategoryWrappers();
  return false;
});

$(document).ready(function () {
  $('.blogglossary-search-input').on('input', function () {
    var searchTerm = $(this).val().toLowerCase();

    $('.pageDocuments_categoryWrapper').hide();

    $('.pageDocuments_categoryWrapper').filter(function () {
      var h3Text = $(this).find('h3').text().toLowerCase();
      return h3Text.includes(searchTerm);
    }).show();

    $('.sidebar-link').removeClass('active');

    var found = false;

    $('.pageDocuments_categoryWrapper:visible').each(function () {
      var categoryWrapper = $(this);
      var category = categoryWrapper.attr('data-category-wrapper');

      var sidebarLink = $('.sidebar-link[data-category="' + category + '"]');
      if (sidebarLink.length > 0) {
        sidebarLink.addClass('active');
        found = true;
      }
    });

    // Check if the input value is empty and set 'active' class for [data-category="all"]
    if (searchTerm === '') {
      $('.sidebar-link[data-category="all"]').addClass('active');
      // Remove 'active' class from all other categoryLinks
      $(`${selectorss.categoryLinks}[data-category!="all"]`).removeClass('active');
    } else {
      // Remove 'active' class from [data-category="all"] when input is not empty
      $('.sidebar-link[data-category="all"]').removeClass('active');
    }
  });
});

 